"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { resolveLink } from "@/sanity/globals/CTA";
import { DEFAULT_LANGUAGE } from "@/sanity/globals/I18n";
import IQCLogo from "@/components/global/ui/IQCLogo";

const HOME_PATH = "/";

export default function NotFoundContent() {
  // Tracking params live in the URL / localStorage / PostHog, so they only
  // exist after mount. Start from the untracked path so the server-rendered
  // href is valid and hydration matches, then upgrade it.
  const [homeHref, setHomeHref] = useState(HOME_PATH);

  useEffect(() => {
    setHomeHref(resolveLink(HOME_PATH, DEFAULT_LANGUAGE));
  }, []);

  return (
    <div className="min-h-screen bg-[#04271d] flex flex-col items-center justify-center px-[2rem] gap-[6rem]">
      <Link href={homeHref}>
        <IQCLogo width="16rem" height="3rem" />
      </Link>

      <div className="flex items-center gap-[3rem]">
        <p className="text-white font-medium text-[2.5rem] leading-none">404</p>
        <div className="w-[1px] h-[4rem] bg-white/20" />
        <p className="text-white/50 text-base leading-none">
          This page could not be found.
        </p>
      </div>

      <Link
        href={homeHref}
        className="text-accent font-mono text-sm tracking-[0.15em] uppercase hover:text-white transition-colors duration-200"
      >
        ← Back to home
      </Link>
    </div>
  );
}
